import {
    ReadSubscriptionPlanResponse,
    ReadSubscriptionPlanResponseData
} from "../../model/response/subscriptionPlan/ReadSubscriptionPlanResponse.ts";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {SubscriptionPlanService} from "../../service/SubscriptionPlanService.ts";

export type SubscriptionPlanState = {
    loading: boolean;
    subscriptionPlan: ReadSubscriptionPlanResponseData[];
};

const initialState: SubscriptionPlanState = {
    loading: false,
    subscriptionPlan: []
};

const action = {
    read: createAsyncThunk("subscriptionPlan/read", async (_, thunkAPI) => {
        return (await SubscriptionPlanService.read(thunkAPI)).data
    })
}

const slice = createSlice({
    name: "subscriptionPlan",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.read.pending, (state) => {
                state.loading = true
            }).addCase(action.read.fulfilled, (state, action) => {
            const response = action.payload as ReadSubscriptionPlanResponse;
            state.subscriptionPlan = response.data
        })
    }
})

export const subscriptionPlan = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions,
}